import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import config from "../../../config.json";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import EditPartner from "../../SystemAdministration/ManagePartner/EditPartner";
import { getPartnerListByType, getRecruiterPartners, loadPartnerListByrecType, loadPartnerListByType, loadRecruiterPartners, partnerListByRecType } from "../../../app/store/partner";
import { addNewRates, getRateUpdatedStatus, ratesReceived, updateRate } from "../../../app/store/rates";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationData } from "../../../app/store/application";
import { candidateUpdated, getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { getAlert } from "../../../services/appAlerts";
import { loadRecruiters } from "../../../app/store/recruiter";
import { getDataTypeApplicationReports, loadDataTypeApplicationReports } from "../../../app/store/reports";
import { getCurrentUser } from "../../../app/store/auth";

const Recruiter = (props) => {

  const { candidateObj, actType, handleNextTab, updateSelectedObject, rateHistory } = props;

  const [recruiters, setRecruiters] = useState([]);
  const [recruiterId, setRecruiterId] = useState(0);
  const [recruiterRate, setRecruiterRate] = useState(0);
  const [recuiterLessFee, setRecuiterLessFee] = useState(0);
  const [recruiterFinalRate, setRecruiterFinalRate] = useState(0);
  const [partnerType, setPartnerType] = useState("Recruiter");
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [ShowHideRec, setShowHideRec] = useState(false);
  const [showDetailRec, setShowDetailRec] = useState(false);
  const [fetchValue, setFetchValue] = useState(false);
  const [allReportData, setAllReportData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [selectedJsonData, setSelectedJsonData] = useState("");
  const [partnerListByType, setPartnerListByType] = useState([]);
  const [compName, setCompName] = useState("");
  const [btnUnable, setBtnUnable] = useState(false);
  // const [dropdownKey, setDropdownKey] = useState("");

  const recruiterPartnersSelector = useSelector(getRecruiterPartners);
  const rateUpdatedStatusSelector = useSelector(getRateUpdatedStatus);
  const partnerListByTypeSelector = useSelector(partnerListByRecType);
  const dataTypeApplicationReportsSelector = useSelector(getDataTypeApplicationReports);

  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus)

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  useEffect(() => {
    dispatch(loadRecruiterPartners(partnerType))
  }, []);

  useEffect(() => {
    setPartnerListByType(partnerListByTypeSelector);
    setFetchValue(false)
  }, [partnerListByTypeSelector]);

  useEffect(() => {
    if (recruiterId > 0) {
      dispatch(loadPartnerListByrecType(partnerType, recruiterId));
    }
  }, [recruiterId]);

  useEffect(() => {
    if (recruiterId > 0 && partnerListByType.length > 0) {
      const partner = partnerListByType.filter((x) => x.fuid === parseInt(recruiterId));
      if (partner.length > 0) {
        setSelectedJsonData(partner[0].contact1?.performerData || "");
      } else {
        setSelectedJsonData("");
      }
    } else {
      setSelectedJsonData("");
    }
  }, [recruiterId, partnerListByType]);


  useEffect(() => {
    if (recruiterPartnersSelector.length > 0) {
      const recList = recruiterPartnersSelector.filter((x) => x.createdBy !== "");
      setRecruiters(recList);
      setFetchValue(false)
      dispatch(loadDataTypeApplicationReports());
    }
  }, [recruiterPartnersSelector]);

  useEffect(() => {
    if (dataTypeApplicationReportsSelector.length > 0) {
      const rptDt = dataTypeApplicationReportsSelector;
      setAllReportData(rptDt);
    }
  }, [dataTypeApplicationReportsSelector]);

  useEffect(() => {

    if (!candidateObj) {
      setRecruiterId(0);
      // setRecruiterRate(0)
    }

    if (candidateObj?.recruiter)
      setRecruiterId(candidateObj.recruiter.fuid);

    const data = { ...rateHistory[rateHistory.length - 1] };
    if (data["recruiterRate"]) {
      setRecruiterFinalRate(data["recruiterRate"])
      setRecuiterLessFee(data["recruiterTechFee"] || 0)
      setRecruiterRate(parseFloat(data["recruiterRate"]) + parseFloat(data["recruiterTechFee"] || 0))
    } else if (actType === "edit") {
      setRecruiterFinalRate("")
      setRecuiterLessFee("")
      setRecruiterRate("")
    }
    // else
    //   if (candidateObj?.rates) {
    //     setRecruiterRate(candidateObj.rates.recruiterRate ?? 0);
    //   }

    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp)
        setAworkfinityApp(obj.aWorkfinityApp);
    }
    setBtnUnable(false)

  }, [candidateObj, rateHistory]);

  useEffect(() => {
    if (allReportData.length > 0) {
      let rptData = [];
      rptData = allReportData.filter((x) => x.name === "RecruiterEnrollmentForm");
      setReportData(rptData);
    }

  }, [allReportData])

  const handleSubmit = (btnType) => {
    if (!candidateObj?.performerid) {
      getAlert("", "Save candidate details before assigning recruiter", "warning");
      return;
    }

    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];

    if (recruiterId > 0) {
      const subs = recruiters.filter(x => x.fuid === recruiterId);
      if (subs.length > 0) {
        const subDetails = JSON.parse(subs[0].createdBy);
        const appEntity = subDetails[appName];
        aWorkfinityAppEntity["recruiterenrollmentform"] = appEntity["recruiterenrollmentform"];
        NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
        setAworkfinityApp(NewAWorkfinityApp);
        setBtnUnable(true)
        const formData = new FormData();
        formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
        formData.append("subcontractor", "");
        formData.append("recruiter", recruiterId);
        formData.append("perfId", candidateObj.performerid);
        dispatch(updateNewCandidate(formData));
        // if (actType === "edit") {
        //   updateSelectedObject(candidateObj.performerid, aworkfinityApp);
        // } else {
        //   updateSelectedObject(candidateObj.performerid);
        // }
        //handleSaveRates();

        // if (actType === "edit"){
        //   getAlert("", "Updated Successfully", "success");
        // }
        // else{
        //   getAlert("", "Saved Successfully", "success");
        // } 
        //updateSelectedObject(candidateObj.performerid);
        //dispatch(ratesReceived([]));
        //handleNextTab(btnType);
        setCompName("recruiter")
      }
    }

  };

  const handleUpdaterates = () => {
    const data = { ...rateHistory[rateHistory.length - 1] };
    const rateObj = {
      performerId: candidateObj.performerid,
      id: data.id,
      addedBy: currentUser.id,
      notes: data["notes"],
      subcontractorRate: data["subcontractorRate"],
      recruiterRate: recruiterFinalRate || 0,
      SubcontractorTechFee: data["subcontractorTechFee"] || 0,
      CandidateTechFee: data["candidateTechFee"] || 0,
      RecruiterTechFee: recuiterLessFee || 0,
      AgencyTechFee: data["agencyTechFee"] || 0,
      candidateRate: data["candidateRate"] || 0,
      agencyRate: data["agencyRate"] || 0,
      candidateEffectiveDate: data["candidateEffectiveDate"] || new Date().toISOString(),
      agencyEffectiveDate: data["agencyEffectiveDate"] || new Date().toISOString(),
      subcontractorEffectiveDate: data["subcontractorEffectiveDate"] || new Date().toISOString(),
      recruiterEffectiveDate: data["recruiterEffectiveDate"] || new Date().toISOString(),
    };
    dispatch(addNewRates(rateObj))
  }

  useEffect(() => {

    if (candidateUpatedStatusSelector && compName === "recruiter") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
        handleUpdaterates();
      }
      else {
        getAlert("", "Saved Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp);
      handleSaveRates();
      dispatch(candidateUpdated(null));
      //handleNextTab(btnType);
    }
  }, [candidateUpatedStatusSelector])


  const getAttributeValue = (d, t, att) => {
    if (d?.appData && d.appData === "") return "";
    const itemValues = JSON.parse(d.appData);
    const appShortName = Object.keys(itemValues)[1];
    const items = itemValues[appShortName][t.name.toLowerCase()];
    return items && items["@" + att];
  };

  const getAttribute = (t) => {
    if (t?.data && t?.data !== "") {
      const items = JSON.parse(t.data);
      return items;
    }
    return [];
  };

  const handleAddEditRecruiter = (data) => {
    if (data === "exit") {
      setShowHideRec(!ShowHideRec);
      dispatch(loadRecruiterPartners(partnerType));
      setFetchValue(true)
    }
  };

  const handleSaveRates = () => {
    const frmData = new FormData();
    frmData.append("id", candidateObj.performerid);
    frmData.append("type", "recruiter");
    frmData.append("recRate", recruiterFinalRate || 0);
    frmData.append("recTechFee", recuiterLessFee || 0);
    dispatch(updateRate(frmData));
  };

  useEffect(() => {
    const rate = parseFloat(recruiterRate) || 0;
    const lessFee = parseFloat(recuiterLessFee) || 0;

    const finalRate = rate - lessFee;
    setRecruiterFinalRate(isNaN(finalRate) ? 0 : finalRate);
  }, [recruiterRate, recuiterLessFee]);

  const ChangeRatePerHour = (rateVal) => {
    const rate = parseFloat(rateVal) || 0;
    setRecruiterRate(rate);
  };

  const ChangeLessTechFee = (rateVal) => {
    const fee = parseFloat(rateVal) || 0;
    if (fee <= recruiterRate || isNaN(fee)) {
      setRecuiterLessFee(fee);
    }
  };

  const handleRecShow = () => {
    setShowHideRec(!ShowHideRec)
    setShowDetailRec(false)
  }

  const handleRecDetails = () => {
    setShowHideRec(false);
    setShowDetailRec(!showDetailRec);
  };

  const handleChangeRecruiter = ({ currentTarget: input }) => {
    const id = input.value;
    setRecruiterId(parseInt(id))
    setShowHideRec(false)
    setShowDetailRec(false)
  }

  const btnDisabled = recruiterId > 0 && recruiterRate > 0;

  return (
    <div className="wf-recruiter-tab-container col-md-12">
      <style>{`
        /* Premium custom styles for Recruiter Tab */
        .wf-recruiter-tab-container .btn-outline-primary-custom {
          color: #2563eb !important;
          border: 1.5px solid #cbd5e1 !important;
          background: #ffffff !important;
          font-weight: 700 !important;
          font-size: 12.5px !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        }
        .wf-recruiter-tab-container .btn-outline-primary-custom:hover {
          color: #2563eb !important;
          border-color: #2563eb !important;
          background: #eff6ff !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px rgba(37, 99, 235, 0.08) !important;
        }

        .wf-recruiter-tab-container .btn-outline-info-custom {
          color: #0f766e !important;
          border: 1.5px solid #cbd5e1 !important;
          background: #ffffff !important;
          font-weight: 700 !important;
          font-size: 12.5px !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
        }
        .wf-recruiter-tab-container .btn-outline-info-custom:hover {
          color: #0f766e !important;
          border-color: #0f766e !important;
          background: #f0fdfa !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px rgba(15, 118, 110, 0.08) !important;
        }

        .wf-recruiter-tab-container .wf-info-banner {
          background: #eff6ff !important;
          border-left: 4px solid #3b82f6 !important;
          padding: 12px 16px !important;
          border-radius: 0 8px 8px 0 !important;
          box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03) !important;
          margin-bottom: 20px !important;
        }
        .wf-recruiter-tab-container .wf-info-banner-icon {
          color: #2563eb !important;
          font-size: 15px !important;
          flex-shrink: 0 !important;
        }
        .wf-recruiter-tab-container .wf-info-banner-text {
          color: #1e3a8a !important;
          font-size: 12.5px !important;
          font-weight: 600 !important;
          line-height: 1.5 !important;
        }

        .wf-recruiter-tab-container label {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 6px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-recruiter-tab-container .wf-input-wrap {
          position: relative !important;
          width: 100% !important;
        }
        .wf-recruiter-tab-container .wf-input-wrap .wf-input-icon {
          position: absolute !important;
          left: 12px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          color: #94a3b8 !important;
          font-size: 13px !important;
          pointer-events: none !important;
          transition: color 0.2s ease !important;
          z-index: 10 !important;
        }
        .wf-recruiter-tab-container .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb !important;
        }

        .wf-recruiter-tab-container .form-control {
          border-radius: 9px !important;
          border: 1.5px solid #cbd5e1 !important;
          padding: 8px 13px 8px 35px !important; /* Left padding prevents icon-text overlap */
          font-size: 13.5px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          width: 100% !important;
        }
        .wf-recruiter-tab-container .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }
        .wf-recruiter-tab-container select.form-control {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
          padding-right: 32px !important;
        }
        .wf-recruiter-tab-container select.form-control:focus {
          background: #fafbff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
        }

        .wf-recruiter-tab-container .btn-primary-custom {
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          color: #ffffff !important;
          font-weight: 700 !important;
          font-size: 13.5px !important;
          padding: 8px 24px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.12), 0 2px 4px -1px rgba(37, 99, 235, 0.06) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        .wf-recruiter-tab-container .btn-primary-custom:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.18), 0 4px 6px -2px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-recruiter-tab-container .btn-primary-custom:disabled {
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }

        .wf-recruiter-tab-container .wf-detail-table-card {
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03) !important;
          overflow: hidden !important;
          margin-top: 20px !important;
        }
        .wf-recruiter-tab-container .wf-detail-table-card .card-header {
          background: #f8fafc !important;
          border-bottom: 1px solid #e2e8f0 !important;
          padding: 12px 16px !important;
        }
        .wf-recruiter-tab-container .wf-detail-table {
          width: 100% !important;
          border-collapse: collapse !important;
        }
        .wf-recruiter-tab-container .wf-detail-table td {
          padding: 10px 16px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          font-size: 13px !important;
          vertical-align: middle !important;
        }
        .wf-recruiter-tab-container .wf-detail-table td.wf-detail-label {
          background-color: #f8fafc !important;
          font-weight: 700 !important;
          color: #475569 !important;
          width: 20% !important;
          text-transform: uppercase !important;
          font-size: 10.5px !important;
          letter-spacing: 0.6px !important;
        }
        .wf-recruiter-tab-container .wf-detail-table td.wf-detail-value {
          color: #1e293b !important;
          width: 30% !important;
          font-weight: 500 !important;
        }
      `}</style>

      <div className="row">
        {/* Action Button Toolbar */}
        <div className="wf-sub-action-toolbar d-flex align-items-center mb-4 gap-3 pl-3 pr-3 w-100">
          <button
            type="button"
            className="btn-outline-primary-custom mr-3"
            onClick={() => handleRecShow()}
          >
            <i className="fa fa-plus-circle" /> Add New Recruiter
          </button>
          {recruiterId ? (
            <button
              type="button"
              className="btn-outline-info-custom"
              onClick={() => handleRecDetails()}
            >
              <i className={`fa ${showDetailRec ? "fa-eye-slash" : "fa-eye"}`} />
              {showDetailRec ? "Hide Recruiter Details" : "View Recruiter Details"}
            </button>
          ) : null}
        </div>

        {!ShowHideRec ? (
          <>
            {/* Info Message Banner */}
            <div className="col-md-12 pl-3 pr-3">
              <div className="wf-info-banner d-flex align-items-center gap-3">
                <i className="fa fa-info-circle wf-info-banner-icon" />
                <span className="wf-info-banner-text">
                  To assign a recruiter to this candidate, select the recruiter from the dropdown and configure the rates below.
                </span>
              </div>
            </div>

            {/* Form Fields Grid */}
            <div className="col-md-3 form-group">
              <label htmlFor="recruiter">
                Select Recruiter
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-handshake-o wf-input-icon" />
                <select
                  name="recruiter"
                  disabled={fetchValue}
                  id="recruiter"
                  className="form-control"
                  onChange={handleChangeRecruiter}
                  value={recruiterId}
                >
                  <option value="">Not Applicable</option>
                  {recruiters.map((item) => (
                    <option key={item.fuid} value={item.fuid}>{item.label}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="rate">
                Rate/Hour-Paid to Recruiter $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-usd wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="rate"
                  id="rate"
                  value={recruiterRate}
                  disabled={!recruiterId}
                  onChange={({ currentTarget }) => ChangeRatePerHour(currentTarget.value)}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="reclessTechFee">
                Less Tech Fee $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-calculator wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="reclessTechFee"
                  id="reclessTechFee"
                  value={recuiterLessFee}
                  disabled={!recruiterId}
                  onChange={({ currentTarget }) => ChangeLessTechFee(currentTarget.value)}
                  placeholder="0.00"
                />
              </div>
            </div>

            <div className="col-md-3 form-group">
              <label htmlFor="finalRate">
                Final Recruiter Rate $
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-check-circle-o wf-input-icon" />
                <input
                  className="form-control"
                  type="number"
                  name="finalRate"
                  id="finalRate"
                  disabled
                  value={recruiterFinalRate}
                  placeholder="0.00"
                  style={{ background: "#f8fafc", color: "#475569", fontWeight: "700" }}
                />
              </div>
            </div>

            {/* Save Buttons */}
            <div className="col-md-12 text-center form-group mt-4 mb-4">
              <button
                type="button"
                className="btn-primary-custom wf-save-assignment-btn"
                disabled={!btnDisabled || btnUnable}
                onClick={() => handleSubmit("save")}
              >
                <i className="fa fa-check" /> Save Recruiter Assignment
              </button>
              {actType !== "edit" && (
                <button
                  type="button"
                  className="btn-primary-custom ml-2"
                  onClick={() => handleNextTab("next")}
                >
                  <i className="fa fa-arrow-right" /> Next
                </button>
              )}
            </div>

            {/* Recruiter details panel */}
            {showDetailRec && (
              <div className="col-md-12 pl-3 pr-3">
                <div className="wf-detail-table-card">
                  <div className="card-header py-2 px-3">
                    <h4 className="mb-0 text-slate-700" style={{ fontSize: "13px", fontWeight: "700" }}>
                      <i className="fa fa-briefcase mr-2" style={{ color: "#2563eb" }} /> Recruiter Firm Details
                    </h4>
                  </div>
                  <div className="table-responsive">
                    <table className="wf-detail-table">
                      <tbody>
                        {selectedJsonData && reportData.map((t, tIdx) => {
                          const attrs = getAttribute(t);
                          const pairs = [];
                          for (let i = 0; i < attrs.length; i += 2) {
                            pairs.push(attrs.slice(i, i + 2));
                          }
                          return pairs.map((pair, pIdx) => (
                            <tr key={pIdx}>
                              {/* Column 1 */}
                              <td className="wf-detail-label">
                                {pair[0].Label}
                              </td>
                              <td className="wf-detail-value">
                                {getAttributeValue({ appData: selectedJsonData }, t, pair[0].Name) || "N/A"}
                              </td>

                              {/* Column 2 */}
                              {pair[1] ? (
                                <>
                                  <td className="wf-detail-label">
                                    {pair[1].Label}
                                  </td>
                                  <td className="wf-detail-value">
                                    {getAttributeValue({ appData: selectedJsonData }, t, pair[1].Name) || "N/A"}
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td className="wf-detail-label" />
                                  <td className="wf-detail-value" />
                                </>
                              )}
                            </tr>
                          ));
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="w-100 pl-3 pr-3">
            <EditPartner
              handleAddEditRecruiter={handleAddEditRecruiter}
              selectedTab="addEditRecruiter"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Recruiter;
